import { render, staticRenderFns } from "./ElevaTor.vue?vue&type=template&id=22bbd74d&scoped=true"
import script from "./ElevaTor.vue?vue&type=script&lang=js"
export * from "./ElevaTor.vue?vue&type=script&lang=js"
import style0 from "./ElevaTor.vue?vue&type=style&index=0&id=22bbd74d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bbd74d",
  null
  
)

export default component.exports